import { createApp, defineAsyncComponent } from 'vue'

export const initUiKit = (app: ReturnType<typeof createApp>) => {
  const appComponents = [
    {
      name: 'BasePagination',
      component: defineAsyncComponent(
        () => import('@shared/components/BasePagination.vue')
      ),
    },
    {
      name: 'AppButton',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppButton.vue')
      ),
    },
    {
      name: 'AppBreadcrumbs',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppBreadcrumbs.vue')
      ),
    },
    {
      name: 'AppFilterWrapper',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/filters/AppFilterWrapper.vue')
      ),
    },
    {
      name: 'AppFiltersWrapper',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/filters/AppFiltersWrapper.vue')
      ),
    },
    {
      name: 'AppHeading',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppHeading.vue')
      ),
    },
    {
      name: 'AppIcon',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppIcon.vue')
      ),
    },
    {
      name: 'AppInput',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppInput.vue')
      ),
    },
    {
      name: 'AppInputNumber',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppInputNumber.vue')
      ),
    },
    {
      name: 'AppPopconfirm',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppPopconfirm.vue')
      ),
    },
    {
      name: 'AppSearch',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppSearch.vue')
      ),
    },
    {
      name: 'AppSelect',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppSelect.vue')
      ),
    },
    {
      name: 'AppText',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppText.vue')
      ),
    },
    {
      name: 'AppTabs',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppTabs.vue')
      ),
    },
    {
      name: 'AppTable',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/table/AppTable.vue')
      ),
    },
    {
      name: 'AppTabs',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppTabs.vue')
      ),
    },
    {
      name: 'AppTableColumn',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/table/AppTableColumn.vue')
      ),
    },
    {
      name: 'AppSearch',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppSearch.vue')
      ),
    },
    {
      name: 'AppInput',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppInput.vue')
      ),
    },
    {
      name: 'AppBreadcrumbs',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppBreadcrumbs.vue')
      ),
    },
    {
      name: 'AppPopconfirm',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppPopconfirm.vue')
      ),
    },
    {
      name: 'TimeInfoAlert',
      component: defineAsyncComponent(
        () => import('@shared/components/TimeInfoAlert.vue')
      ),
    },
    {
      name: 'AppFilterWrapper',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/filters/AppFilterWrapper.vue')
      ),
    },
    {
      name: 'AppFiltersWrapper',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/filters/AppFiltersWrapper.vue')
      ),
    },
    {
      name: 'AppDragDrop',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/AppDragDrop.vue')
      ),
    },
    {
      name: 'AppCheckbox',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/checkbox/AppCheckbox.vue')
      ),
    },
    {
      name: 'AppCheckboxButton',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/checkbox/AppCheckboxButton.vue')
      ),
    },
    {
      name: 'AppCheckboxGroup',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/checkbox/AppCheckboxGroup.vue')
      ),
    },
    {
      name: 'AppRadio',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/radio/AppRadio.vue')
      ),
    },
    {
      name: 'AppRadioButton',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/radio/AppRadioButton.vue')
      ),
    },
    {
      name: 'AppRadioGroup',
      component: defineAsyncComponent(
        () => import('@shared/components/ui/radio/AppRadioGroup.vue')
      ),
    },
  ]

  appComponents.forEach((item) => {
    app.component(item.name, item.component)
  })
}
